export enum TimeUnitMultiplier {
  Undefined = 0,
  Millisecond = 1,
  Second = 1000,
  Minute = 60000,
  Hour = 3600000,
  Day = 86400000,
  Month = 2629746000,
  Year = 31556952000,
}
